// client/src/routes/app/properties/$propertyId/co-owners.tsx — SCR-PROP-003 tab „Coproprietari"
// · PROP-004 (04 §8.3; 03 §7.5). The quota editor of 05 PROP-004 criterion 1.

import { createFileRoute } from '@tanstack/react-router';

import { CoOwnersTab } from '@/features/properties/CoOwnersTab';

export const Route = createFileRoute('/app/properties/$propertyId/co-owners')({
  component: CoOwnersScreen,
});

function CoOwnersScreen() {
  const { propertyId } = Route.useParams();
  return <CoOwnersTab propertyId={propertyId} />;
}
